import { continueToPaymentAnalyticsData } from "@/components/checkout/checkoutConstants"
import { getDeliveryOption } from "@/components/checkout/DeliveryOptions/utils"
import { pushAnalyticsObjToDataLayer } from "@/utils/helper"
import { getEventInfo } from "@/components/checkout/checkoutHelperFunction"
import { getShippingEventInfo } from "@/components/checkout/checkoutHelper"

export const addContinueToPaymentAnalyticsData = selected => {
  const eventInfo = continueToPaymentAnalyticsData(getDeliveryOption(selected))
  pushAnalyticsObjToDataLayer(eventInfo, "cmp:click")
}

export const addServiceAnalyticsData = (type, link) => {
  const eventInfo = getEventInfo(type, link, true)
  pushAnalyticsObjToDataLayer(eventInfo, "cmp:click")
}

export const addCheckoutSignInAnalyticsData = type => {
  const eventInfo = getShippingEventInfo(type, true)
  pushAnalyticsObjToDataLayer(eventInfo, "cmp:click")
}
